import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static values = { checked: { type: Boolean, default: false } };
  declare checkedValue: boolean;

  static targets = ["active", "inactive", "fieldset"];
  declare activeTarget: HTMLElement;
  declare fieldsetTarget: HTMLFieldSetElement;
  declare inactiveTarget: HTMLElement;

  toggle() {
    this.checkedValue = !this.checkedValue;
  }

  checkedValueChanged(value: boolean) {
    if (value) {
      this.fieldsetTarget.classList.remove("hidden");
      this.activeTarget.classList.remove("hidden");
      this.inactiveTarget.classList.add("hidden");
    } else {
      this.fieldsetTarget.classList.add("hidden");
      this.activeTarget.classList.add("hidden");
      this.inactiveTarget.classList.remove("hidden");
    }
  }
}
